import { createRouter, createWebHistory } from 'vue-router'
import store from '../store';
import MainView from '../views/MainView.vue'
import AuthView from '../views/AuthView.vue'
import LoginPage from '../components/LoginPage.vue'
import RegisterPage from '../components/RegisterPage.vue'
import Dashboard from '../components/Parents/Dashboard.vue'
import ErrorNotFound from '../components/Utils/ErrorNotFound.vue';
import AccountVerification from '../components/Parents/AccountVerification.vue';
import SemesterSchoolyear from '../components/Parents/SemesterSchoolyear.vue';
import Schedules from '../components/Parents/Schedules.vue';
import AccountManagement from '../components/Parents/AccountManagement.vue';
import FacultyLoad from '../components/Parents/FacultyLoad.vue';
import FacultyWorkload from '../components/Parents/FacultyWorkload.vue';
import ComplianceSubmission from '../components/Parents/ComplianceSubmission.vue';
import ComplianceReview from '../components/Parents/ComplianceReview.vue';
import ComplianceApproval from '../components/Parents/ComplianceApproval.vue';
import Profile from '../components/Parents/Profile.vue';
import WorkloadPrepare from '../components/Parents/WorkloadPrepare.vue';
import WorkloadRecommending from '../components/Parents/WorkloadRecommending.vue';
import WorkloadPreApprove from '../components/Parents/WorkloadPreApprove.vue';
import WorkloadApproval from '../components/Parents/WorkloadApproval.vue';
import FacultyCourseLoad from '../components/Parents/FacultyCourseLoad.vue';
import RepUnitLoading from '../components/Parents/RepUnitLoading.vue';
import RepViewLoad from '../components/Parents/RepViewLoad.vue';
import VPAAStaffRepLoad from '../components/Parents/VPAAStaffRepLoad.vue';
import VPAAReport from '../components/Parents/VPAAReport.vue';
import Courses from '../components/Parents/Courses.vue';
import DeansReport from '../components/Parents/DeansReport.vue';
import ViewWorkload from '../components/Parents/ViewWorkload.vue';
import RegistrarReports from '../components/Parents/RegistrarReports.vue';
import DeptChairComplianceChecking from '../components/Parents/DeptChairComplianceChecking.vue';
import DeansComplianceChecking from '../components/Parents/DeansComplianceChecking.vue';
import FacultyComplianceChecked from '../components/Parents/FacultyComplianceChecked.vue';
import Compliances from '../components/Parents/Compliances.vue';
import DirectorFacultyCourseLoad from '../components/Parents/DirectorFacultyCourseLoad.vue';
import Announcements from '../components/Parents/Announcements.vue';
import MentoringCommitment from '../components/Parents/Mentoring&Commitment.vue';
import VPAAMentoringCommitment from '../components/Parents/VPAAMentoring&Commitment.vue';
import RecommendationComplianceMatrix from '@/components/Parents/Recommendation&ComplianceMatrix.vue';

const routes = [
  {
    path: '/',
    component: AuthView,
    meta: { alreadyAuth: true },
    children: [
      {
        path: '/',
        name: 'login',
        component: LoginPage,
      },
      {
        path: '/register',
        name: 'register',
        component: RegisterPage,
      },
    ]
  },

  {
    path: '/admin',
    name: 'admin',
    meta: { routeForAdmin: true },
    component: MainView,
    children: [
      {
        path: '/admin/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/admin/accounts-verification',
        component: AccountVerification,
        meta: {
          title: 'Accounts Verification'
        }
      },
      {
        path: '/admin/accounts-management',
        component: AccountManagement,
        meta: {
          title: 'Accounts Management'
        }
      },
      {
        path: '/admin/announcements',
        component: Announcements,
        meta: {
          title: 'Announcements'
        }
      },
      {
        path: '/admin/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/vice-president',
    name: 'vice-president',
    meta: { routeForVP: true },
    component: MainView,
    children: [
      {
        path: '/vice-president/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/vice-president/schedules',
        component: Schedules,
        meta: {
          title: 'Schedules'
        }
      },
      {
        path: '/vice-president/approval-workload',
        component: WorkloadApproval,
        meta: {
          title: 'Approve Faculty Workload'
        }
      },
      {
        path: '/vice-president/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/dean',
    name: 'dean',
    meta: { routeForDean: true },
    component: MainView,
    children: [
      {
        path: '/dean/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/dean/compliance-approval',
        component: ComplianceApproval,
        meta: {
          title: 'Compliance Approval'
        }
      },
      {
        path: '/dean/compliance-checking',
        component: DeansComplianceChecking,
        meta: {
          title: 'Compliance Checking'
        }
      },
      {
        path: '/dean/recommending-approval-workload',
        component: WorkloadRecommending,
        meta: {
          title: 'Recommending Approval Faculty Workload'
        }
      },
      {
        path: '/dean/mentoring-and-commitment',
        component: MentoringCommitment,
        meta: {
          title: 'Mentoring and Commitment'
        }
      },
      {
        path: '/dean/reports',
        component: DeansReport,
        meta: {
          title: 'Reports'
        }
      },
      {
        path: '/dean/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/department-chairperson',
    name: 'department-chairperson',
    meta: { routeForProgChair: true },
    component: MainView,
    children: [
      {
        path: '/department-chairperson/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/department-chairperson/compliance-review',
        component: ComplianceReview,
        meta: {
          title: 'Compliance Review'
        }
      },
      {
        path: '/department-chairperson/compliance-checking',
        component: DeptChairComplianceChecking,
        meta: {
          title: 'Compliance Checking'
        }
      },
      {
        path: '/department-chairperson/prepare-faculty-workload',
        component: WorkloadPrepare,
        meta: {
          title: 'Prepare Faculty Workload'
        }
      },
      {
        path: '/department-chairperson/faculty-course-load',
        component: FacultyCourseLoad,
        meta: {
          title: 'Faculty Course Load'
        }
      },
      {
        path: '/department-chairperson/courses',
        component: Courses,
        meta: {
          title: 'Courses'
        }
      },
      {
        path: '/department-chairperson/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/faculty',
    name: 'faculty',
    meta: { routeForFaculty: true },
    component: MainView,
    children: [
      {
        path: '/faculty/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/faculty/my-course-load',
        component: FacultyLoad,
        meta: {
          title: 'My Course Load'
        }
      },
      {
        path: '/faculty/compliance-submission',
        component: ComplianceSubmission,
        meta: {
          title: 'Compliance Submission'
        }
      },
      {
        path: '/faculty/compliance-checked',
        component: FacultyComplianceChecked,
        meta: {
          title: 'Compliance Checked'
        }
      },
      {
        path: '/faculty/rep-load-release',
        component: RepViewLoad,
        meta: {
          title: 'REP Load Release'
        }
      },
      {
        path: '/faculty/my-workload',
        component: ViewWorkload,
        meta: {
          title: 'My Workload'
        }
      },
      {
        path: '/faculty/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/vpaa-staff',
    name: 'vpaa-staff',
    meta: { routeForVPStaff: true },
    component: MainView,
    children: [
      {
        path: '/vpaa-staff/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/vpaa-staff/accounts-verification',
        component: AccountVerification,
        meta: {
          title: 'Accounts Verification'
        }
      },
      {
        path: '/vpaa-staff/schedules',
        component: Schedules,
        meta: {
          title: 'Schedules'
        }
      },
      {
        path: '/vpaa-staff/semester-schoolyear',
        component: SemesterSchoolyear,
        meta: {
          title: 'Semester and Schoolyear'
        }
      },
      {
        path: '/vpaa-staff/faculty-workload',
        component: FacultyWorkload,
        meta: {
          title: 'Faculty Workload'
        }
      },
      {
        path: '/vpaa-staff/rep-load',
        component: VPAAStaffRepLoad,
        meta: {
          title: 'REP Load Release'
        }
      },
      {
        path: '/vpaa-staff/mentoring-and-commitment',
        component: VPAAMentoringCommitment,
        meta: {
          title: 'Mentoring and Commitment'
        }
      },
      {
        path: '/vpaa-staff/recommendation-and-compliance',
        component: RecommendationComplianceMatrix,
        meta: {
          title: 'Recommendation & Compliance Matrix'
        }
      },
      {
        path: '/vpaa-staff/reports',
        component: VPAAReport,
        meta: {
          title: 'Reports'
        }
      },
      {
        path: '/vpaa-staff/compliances',
        component: Compliances,
        meta: {
          title: 'Compliances'
        }
      },
      {
        path: '/vpaa-staff/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/rep-staff',
    name: 'rep-staff',
    meta: { routeForREPStaff: true },
    component: MainView,
    children: [
      {
        path: '/rep-staff/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/rep-staff/rep-load',
        component: RepUnitLoading,
        meta: {
          title: 'REP Loading'
        }
      },
      {
        path: '/rep-staff/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/director',
    name: 'director',
    meta: { routeForDirector: true },
    component: MainView,
    children: [
      {
        path: '/director/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/director/pre-approval-workload',
        component: WorkloadPreApprove,
        meta: {
          title: 'Pre Approve Faculty Workload'
        }
      },
      {
        path: '/director/faculty-course-load',
        component: DirectorFacultyCourseLoad,
        meta: {
          title: 'Faculty Course Load'
        }
      },
      {
        path: '/director/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/registrar',
    name: 'registrar',
    meta: { routeForRegistrar: true },
    component: MainView,
    children: [
      {
        path: '/registrar/dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/registrar/reports',
        component: RegistrarReports,
        meta: {
          title: 'Reports'
        }
      },
      {
        path: '/registrar/profile',
        component: Profile,
        meta: {
          title: 'Profile'
        }
      }
    ]
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'ErrorView',
    component: ErrorNotFound,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { top: 0}
  },
})

router.beforeEach((to, from, next) => {
  let user = store.state.user;
  let currentRole = store.state.currentRole

  if (to.matched.some(rec => rec.meta.alreadyAuth)) {
      if (user) {
          if (currentRole.id == 1) {
              next('/admin/dashboard');
          }
          if (currentRole.id == 2) {
            next('/vice-president/dashboard');
          }
          if (currentRole.id == 3) {
            next('/director/dashboard');
          }
          if (currentRole.id == 4) {
            next('/dean/dashboard');
          }
          if (currentRole.id == 5) {
            next('/department-chairperson/dashboard');
          }
          if (currentRole.id == 6) {
            next('/vpaa-staff/dashboard');
          }
          if (currentRole.id == 7) {
            next('/rep-staff/dashboard');
          }
          if (currentRole.id == 8) {
            next('/registrar/dashboard');
          }
          if (currentRole.id == 9) {
            next('/faculty/dashboard');
          }
      } else {
          next();
      }
  } 
  else if (to.matched.some(record => record.meta.routeForAdmin)) {
      if (!user || currentRole.id !== 1) {
          next('/');
      } else {
          next();
      }
  } 

  else if (to.matched.some(record => record.meta.routeForVP)) {
    if (!user || currentRole.id !== 2) {
        next('/');
    } else {
        next();
    }
  }

  else if (to.matched.some(record => record.meta.routeForDirector)) {
    if (!user || currentRole.id !== 3) {
        next('/');
    } else {
        next();
    }
}

  else if (to.matched.some(record => record.meta.routeForDean)) {
    if (!user || currentRole.id !== 4) {
        next('/');
    } else {
        next();
    }
  }

  else if (to.matched.some(record => record.meta.routeForProgChair)) {
    if (!user || currentRole.id !== 5) {
        next('/');
    } else {
        next();
    }
  }

  else if (to.matched.some(record => record.meta.routeForVPStaff)) {
      if (!user || currentRole.id !== 6) {
          next('/');
      } else {
          next();
      }
  }

  else if (to.matched.some(record => record.meta.routeForREPStaff)) {
      if (!user || currentRole.id !== 7) {
          next('/');
      } else {
          next();
      }
  }

  else if (to.matched.some(record => record.meta.routeForRegistrar)) {
      if (!user || currentRole.id !== 8) {
          next('/');
      } else {
          next();
      }
  }

  else if (to.matched.some(record => record.meta.routeForFaculty)) {
    if (!user || currentRole.id !== 9) {
        next('/');
    } else {
        next();
    }
  }
  else {
      next();
  }
});

export default router
